<docs>
# UiKit - Button
> *generic way to create a specific themed cta*
</docs>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue';
import IconCta from './Icon.vue';
import BaseCta from './index.vue';
import LinkCta from './Link.vue';
import NavCta from './Nav.vue';
import PrimaryCta from './Primary.vue';
import ThemeCta from './Theme.vue';

const UiThemedButton = defineComponent({
  name: "UiButtonThemed",
  components: {
    PrimaryCta,
    NavCta,
    LinkCta,
    ThemeCta,
    IconCta,
    BaseCta,
  },
  props:{
    theme: {
      type: String as PropType<ButtonTheme>,
      default: 'link'
    },
  },
  setup(props){
    /* get dynamic component from cpn name */
    const component = computed(():string => {
      switch (props.theme) {
        case 'primary':
          return 'PrimaryCta';
        case 'nav':
          return 'NavCta';
        case 'link':
          return 'LinkCta';
        case 'theme':
          return 'ThemeCta';
        case 'icon':
          return 'IconCta';
        case 'reset':
        default:
          return 'BaseCta';
      }
    });

    return {
      component,
    }
  }
});
export default UiThemedButton
</script>

<template>
  <component :is="component"
             class="UiButtonThemed"
             v-bind="$props"
             :animated="component !== 'BaseCta' ? undefined : false"
  >
    <slot />
  </component>
</template>
